export default __webpack_public_path__ + "static/media/help1.a4fb598d.svg";